import React, { Component } from 'react';
import './evaluation-report.scss';
import { ImageConstants, Constants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import WronglyAnswered from '../../../common/wrong-answers-modal/wrong-answers-modalV1/wrong-answers-modal'
import HomeworkApi from '../../../../apis/homework'
import Loading from '../../../common/loading/loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import StudentDetailReport from '../student-level-report/student-detail/student-detail'
import ChapterEloAssessmentReport from './student-report/student-report';
import CommonApi from '../../../../apis/common';


class HomeworkEvalutionReport extends Component {
    state = {
        noviceUsers: [
        ],
        types: [
            {
                title: "Novice",
                threshold: "< 50%",
                color: "#8B8BF6",
                mark: "30%" //for demo only
            },
            {
                title: "Proficient",
                threshold: "51%-80%",
                color: "#FFBB7C",
                mark: "60%"
            },
            {
                title: "Advance",
                threshold: "> 80%",
                color: "#80D2F4",
                mark: "90%"
            }
        ],
        showStudentReport: false

    }


    // selectedItem = {}

    // constructor(props) {
    //     super(props) 

    //     let chapters = []

    //     chapters.push(this.props.match.params?.chapter)

    //     this.selectedItem = {
    //         class : this.props.match.params?.class,
    //         chapters :  chapters,
    //         createdDate : this.props.match.params?.createdDate
    //     }

    //     console.log(this.selectedItem)


    // }




    componentDidMount() {

        this.getHomeworkEvaluationReport()
        console.log(this.props.selectedItem)
        document.addEventListener('mousedown', this.handleClickEvent, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickEvent, false);
    }

    handleClickEvent = (event) => {
        if (this.studentRef && !this.studentRef.contains(event.target)) {
            this.setState({ showNotCompletedList: false })
        }
    }

    onClickStudent(user) {

        this.setState({ showReport: true, selectedStudent: user, selectedHomework: this.props.selectedItem })
        //this.props.onClickStudent && this.props.onClickStudent(user)
    }


    onShowStudentReport(user) {
        this.setState({ showStudentReport: true, selectedStudent: user, selectedHomework: this.props.selectedItem })
    }

    hideStudentReport() {
        this.setState({ showStudentReport: false })
    }



    getHomeworkEvaluationReport(payload = {}) {

        // if (payload.page) payload.page = 1
        // if (payload.page) payload.limit = this.limit
        // payload.type = this.props.type

        if (this.props.selectedItem) {
            payload.homeworkId = this.props.selectedItem._id
        }

        this.setState({ isLoading: true })

        HomeworkApi.getHomeworkEvaluationReport(payload)
            .then(response => {

                this.setState(
                    {
                        noviceStudents: response.noviceStudents,
                        proficientStudents: response.proficientStudents,
                        advancedStudents: response.advancedStudents,
                        notCompletedStudents: response.notCompletedStudents,
                        isLoading: false
                    })

            }).catch(err => {
            })
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb-1'>
                <span>{`${this.props.selectedItem?.class} >`}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.chapter} >`}</span>
                <span className='pl-2'>{this.getDate(this.props.selectedItem?.createdDateTimestamp)}</span>
            </div>
        )
    }

    onClickBack = () => {

        //this.setState({showReport:false})

        this.props.delegate && this.props.delegate.hideReport && this.props.delegate.hideReport()
    }

    onClickStudentDetailBack = () => {

        this.setState({ showReport: false })

    }

    onClickReportCardInfo = (type, students) => {

        let userIds = []

        for (let i = 0; i < students.length; i++) {
            userIds.push(students[i].userId)
        }

        this.setState({ showWrongAnswersReport: true, userIds, selectedStatus: type })
    }

    hideReport = () => {
        this.setState({ showWrongAnswersReport: false })
    }
    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    onClickNotCompleted = () => {
        this.setState({ showNotCompletedList: true })
    }

    closeStudents() {
        this.setState({ showNotCompletedList: false })
    }

    renderStudentCard() {
        return (
            <div className='students-card' ref={ref => this.studentRef = ref}>

                <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.closeStudents()} src={getImageSource(ImageConstants.CROSS)} />
                    </div>
                </div>

                {this.state.notCompletedStudents?.length ? this.state.notCompletedStudents?.map((item, index) =>
                    <div className='px-4 py-2 row align-items-center'>
                        {/* <div className="profile-avatar text-center mr-2 d-inline-block">
                            <div className="row justify-content-center">
                                {item.image ? <img className="" alt="img" src={`${item.basePath}${item.image}`} />
                                    :
                                    <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                            </div>
                        </div> */}
                        <div className='student-name ml-2'>
                            {item.name}
                        </div>
                    </div>

                )
                    :
                    <div className="text-center pt-4">No Records Found</div>
                }
            </div>
        )
    }


    downloadAllStudentsReportToPDF() {

        if (this.state.isDownloading) return

        let payload = {
            class: this.props.selectedItem.class,
            section: this.props.selectedItem.section,
            sectionId: this.props.selectedItem.sectionId,
            type: this.props.selectedItem.type,
        }

        if (this.props.selectedItem._id) {
            payload.homeworkId = this.props.selectedItem._id ? this.props.selectedItem._id : null
        }

        this.setState({ isDownloading: true })

        CommonApi.getAllStudentsReportPdf(payload).then((response) => {
            console.log(response)
            // Create a temporary URL for the Blob
            // Create a temporary URL for the Blob

            if (!(response instanceof Blob)) {
                //
                console.log('not a blob')
            }

            // Create a temporary URL for the Blob
            const url = window.URL.createObjectURL(response);

            // Create an anchor element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Student Performance Report ' + (new Date).toISOString() + '.zip'; // Name of the downloaded file
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            this.setState({ isDownloading: false })
            alert('Student Report Downloaded Successfully')

        }).catch(err => {
            this.setState({ isDownloading: false })
            console.log(err)
        })
    }




    render() {


        if (this.state.showWrongAnswersReport) {
            return <WronglyAnswered show={this.state.showWrongAnswersReport}
                delegate={this} onClose={this.hideReport}
                userIds={this.state.userIds}
                selectedStatus={this.state.selectedStatus}
                homeworkId={this.props.selectedItem._id}
                selectedItem={this.props.selectedItem}
            />
        }

        if (this.state.showReport) {
            return <StudentDetailReport type={this.props.selectedItem.type}
                delegate={this} selectedItem={this.state.selectedHomework}
                student={this.state.selectedStudent}
                onClickBack={this.onClickStudentDetailBack}
                selectedData={this.selectedItem ? { ...this.selectedItem } : ''}
            />
        }

        if (this.state.showStudentReport) {
            return <ChapterEloAssessmentReport
                type={this.props.selectedItem.type}
                delegate={this} selectedItem={this.state.selectedHomework}
                student={this.state.selectedStudent}
            />
        }



        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}
                <div className='homework-evaluation-report-1'>

                    {/* <div className='mb-5'>
                        <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div> */}

                    {/* <div className='container-1'>
                        <div className='mb-3 item1' >
                            <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                        </div>
                        <div className='item-2'>
                            <span className='screen-title title-center my-5'>Homework Evaluation Report</span>
                        </div>
                    </div>

                    <span>{this.renderBreadcrumb()}</span> */}

                    <div className='mb-3 item1 d-flex justify-content-between' >
                        <div>
                            <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                        </div>

                        <div className="d-flex ">
                            {/* <div className="export-button cursor-pointer mr-3" onClick={() => this.downloadPDF()}>Export Overall Report to PDF</div> */}

                            {
                                this.props.type === 'CLICKER_PRACTICE_STANDARD' && this.props.selectedItem.isStudentBulkReportGenerationDone ?
                                    <div className="export-button cursor-pointer mr-4" onClick={() => this.downloadAllStudentsReportToPDF()}>{this.state.isDownloading ? 'Downloading...' : 'Export All Students Report to PDF'}</div>
                                    :
                                    <></>
                            }
                            {
                                (this.props.type === 'STANDARD' || this.props.type === 'STANDARD_CLASSWORK') && this.props.selectedItem.status === 'PAST_DUE_DATE' && 
                                this.props.selectedItem.completed && this.props.selectedItem.completed.length && (new Date(this.props.selectedItem.createdDateTimestamp) > new Date("2025-10-17T10:03:54.748Z")) ?
                                    <div className="export-button cursor-pointer mr-4" onClick={() => this.downloadAllStudentsReportToPDF()}>{this.state.isDownloading ? 'Downloading...' : 'Export All Students Report to PDF'}</div>
                                    :
                                    <></>
                            }
                        </div>
                    </div>

                    <div className='d-flex align-items-center justify-content-between header-report-card'>
                        <div className='d-flex align-items-center'>
                            <div>
                                <img className='circle-image' src={getImageSource(ImageConstants.EVALUATION_DETAIL_REPORT)} />
                            </div>
                            <div className='ml-2'>
                                <div className=''>
                                    <span className='screen-title-1 title-center'>{`${this.props.selectedItem.type === 'STANDARD' || this.props.selectedItem.type === 'ADAPTIVE' ? 'Homework' : 'Classwork'} Evaluation Report`}</span>
                                    <span>{this.renderBreadcrumb()}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-right pt-4 mr-4 position-relative">
                        <span className="text-danger  cursor-pointer" onClick={this.onClickNotCompleted}><FontAwesomeIcon icon={faTimesCircle} /> Not Completed <span className="not-completed text-primary">{this.state?.notCompletedStudents?.length || 0} Students</span></span>
                        {this.state.showNotCompletedList ? this.renderStudentCard() : ""}
                    </div>
                    <div className='pt-2 report-card-wrapper ml-3'>
                        <div className='report-card novice-border'>
                            <div className='report-card-header' style={{ backgroundColor: '#8B8BF6' }}>
                                <div className='row header-items'>
                                    <div className='col-7 text-center'>
                                        <span><span className='header-title'>Novice</span> | <strong>{'< 50 %'}</strong></span>
                                    </div>
                                    {this.state.noviceStudents && this.state.noviceStudents.length ? <div className='col-4 text-right mr-2'>
                                        <img className='info-icon cursor-pointer' src={getImageSource(ImageConstants.REPORT_CARD_INFO)} onClick={() => this.onClickReportCardInfo('NOVICE', this.state.noviceStudents)} />
                                    </div>
                                        :
                                        <></>}
                                </div>
                            </div>

                            <div className='report-card-body'>

                                {this.state.noviceStudents && this.state.noviceStudents.length ? this.state.noviceStudents.map((user, index) => (
                                    <div className='row mt-4'>
                                        {/* <div className='col-1 pr-0 my-auto pr-4'>
                                            <div className='user-image'>
                                                {user.image ? <img className="user-image" alt="img" src={`${user.basePath}${user.image}`} />
                                                    :
                                                    <img className="user-image" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                            </div>
                                        </div> */}
                                        <div className='col d-flex justify-content-between flex-wrap my-auto ' >
                                            <div className=''>
                                                <span className='user-name cursor-pointer' onClick={() => this.onShowStudentReport(user)}>{user.name}</span>
                                                {/* {user.name.length >= 18 ? "" : <span className=" marks pl-2">( Marks: {user.mark}%)</span>} */}

                                            </div>
                                            <div className={`${user.name.length >= 18 ? "" : ""}`}>
                                                {/* {user.name.length >= 18 ? <span className=" marks">( Marks: {user.mark}%)</span> : <></>} */}
                                                {<span className=" marks mr-1 ">( Marks: {user.mark}%)</span>}
                                                <span className='d-inline'>

                                                    <img className="right-download-icon  pt-1 ml-2 cursor-pointer" src={getImageSource(ImageConstants.DOWNLOAD_ICON_BLUE)} onClick={() => this.onShowStudentReport(user)} />
                                                </span>

                                            </div>


                                        </div>
                                    </div>
                                ))
                                    :

                                    <div className="no-data text-center">
                                        <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                        <div className="empty">This is Empty</div>
                                        <div className="no-student">No Student in this bucket</div>
                                    </div>
                                }

                            </div>
                        </div>
                        <div className='report-card proficient-border'>
                            <div className='report-card-header' style={{ backgroundColor: "#FFBB7C" }}>
                                <div className='row header-items'>
                                    <div className='col-7 text-center'>
                                        <span><span className='header-title'>Proficient</span> | <strong>{'51%-80%'}</strong></span>
                                    </div>
                                    {this.state.proficientStudents && this.state.proficientStudents.length ? <div className='col-4 text-right mr-2'>
                                        <img className='info-icon cursor-pointer' src={getImageSource(ImageConstants.REPORT_CARD_INFO)} onClick={() => this.onClickReportCardInfo('PROFICIENT', this.state.proficientStudents)} />
                                    </div>
                                        :
                                        <></>}
                                </div>
                            </div>

                            <div className='report-card-body'>

                                {this.state.proficientStudents && this.state.proficientStudents.length ? this.state.proficientStudents.map((user, index) => (
                                    <div className='row mt-4'>
                                        {/* <div className='col-1 pr-0 my-auto pr-4'>
                                            <div className='user-image'>
                                                {user.image ? <img className="user-image" alt="img" src={`${user.basePath}${user.image}`} />
                                                    :
                                                    <img className="user-image" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                            </div>
                                        </div> */}
                                        <div className='col d-flex justify-content-between flex-wrap my-auto ' >
                                            <div className=''>
                                                <span className='user-name cursor-pointer' onClick={() => this.onShowStudentReport(user)}>{user.name}</span>
                                                {/* {user.name.length >= 18 ? "" : <span className=" marks pl-2">( Marks: {user.mark}%)</span>} */}

                                            </div>
                                            <div className={`${user.name.length >= 18 ? "" : ""}`}>
                                                {/* {user.name.length >= 18 ? <span className=" marks">( Marks: {user.mark}%)</span> : <></>} */}
                                                {<span className=" marks mr-1 ">( Marks: {user.mark}%)</span>}
                                                <span className='d-inline'>

                                                    <img className="right-download-icon  pt-1 ml-2 cursor-pointer" src={getImageSource(ImageConstants.DOWNLOAD_ICON_BLUE)} onClick={() => this.onShowStudentReport(user)} />
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                ))
                                    :

                                    <div className="no-data text-center">
                                        <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                        <div className="empty">This is Empty</div>
                                        <div className="no-student">No Student in this bucket</div>
                                    </div>
                                }

                            </div>
                        </div>
                        <div className='report-card advance-border'>
                            <div className='report-card-header' style={{ backgroundColor: "#80D2F4" }}>
                                <div className='row header-items'>
                                    <div className='col-7 text-center'>
                                        <span><span className='header-title'>Advance</span> | <strong>{"> 80 %"}</strong></span>
                                    </div>
                                    {this.state.advancedStudents && this.state.advancedStudents.length ? <div className='col-4 text-right mr-2'>
                                        <img className='info-icon cursor-pointer' src={getImageSource(ImageConstants.REPORT_CARD_INFO)} onClick={() => this.onClickReportCardInfo('ADVANCE', this.state.advancedStudents)} />

                                    </div>
                                        :
                                        <></>}
                                </div>
                            </div>

                            <div className='report-card-body'>

                                {this.state.advancedStudents && this.state.advancedStudents.length ? this.state.advancedStudents.map((user, index) => (
                                    <div className='row mt-4'>
                                        {/* <div className='col-1 pr-0 my-auto pr-4'>
                                            <div className='user-image'>
                                                {user.image ? <img className="user-image" alt="img" src={`${user.basePath}${user.image}`} />
                                                    :
                                                    <img className="user-image" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                            </div>
                                        </div> */}
                                        <div className='col d-flex justify-content-between flex-wrap my-auto cursor-pointer' onClick={() => this.onShowStudentReport(user)}>
                                            <div className=''>
                                                <span className='user-name cursor-pointer' onClick={() => this.onShowStudentReport(user)}>{user.name}</span>
                                                {/* {user.name.length >= 18 ? "" : <span className=" marks pl-2">( Marks: {user.mark}%)</span>} */}

                                            </div>
                                            <div className={`${user.name.length >= 18 ? "" : ""}`}>
                                                {/* {user.name.length >= 18 ? <span className=" marks">( Marks: {user.mark}%)</span> : <></>} */}
                                                {<span className=" marks mr-1 ">( Marks: {user.mark}%)</span>}
                                                <span className='d-inline'>

                                                    <img className="right-download-icon  pt-1 ml-2 cursor-pointer" src={getImageSource(ImageConstants.DOWNLOAD_ICON_BLUE)} onClick={() => this.onShowStudentReport(user)} />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                    :
                                    <div className="no-data text-center">
                                        <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                        <div className="empty">This is Empty</div>
                                        <div className="no-student">No Student in this bucket</div>
                                    </div>
                                }

                            </div>
                        </div>
                        {/* ))} */}
                    </div>
                    {/* {this.state.showWrongAnswersReport && <WronglyAnswered show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} userIds={this.state.userIds} selectedStatus={this.state.selectedStatus} homeworkId={this.props.selectedItem?._id} />} */}
                </div >
            </>);
    }
}

export default HomeworkEvalutionReport;